export default "__VITE_ASSET__8d62b0ad__"